import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type { RootState } from '@/store';

import type {
  FontesPendenciaPublicacaoPagina,
  ListarFontesPendenciaPublicacaoInput,
} from '../../types/pendenciasPublicacaoTypes';
import { listarFontesPendenciaPublicacaoService } from './services';

export const listarFontesPendenciaPublicacao = createAsyncThunk<
  FontesPendenciaPublicacaoPagina,
  ListarFontesPendenciaPublicacaoInput,
  { state: RootState; rejectValue: string }
>(
  'arbitro/listarFontesPendenciaPublicacao',
  async (input, { rejectWithValue }) => {
    try {
      return await listarFontesPendenciaPublicacaoService(input);
    } catch (erro) {
      return rejectWithValue(getErrorMessage(erro));
    }
  },
  {
    condition: ({ id, pendenciaId, page = 1 }, { getState }) => {
      if (page === 1) return true;
      const atual = getState().arbitro.fontesPendenciaPublicacao;
      return (
        atual.processoId === id &&
        atual.pendenciaId === pendenciaId &&
        !atual.loading &&
        page === atual.pagination.page + 1 &&
        page <= atual.pagination.totalPages
      );
    },
  },
);
